import React from 'react'
import { Link } from 'react-router-dom'
import { useCartItem } from 'lib/core/hooks/useCartItem'
import { Spinner } from 'lib/ui/components'
import { Price } from 'lib/shared/components'
import { ReactComponent as CloseSvg } from 'lib/core/resources/svg/close.svg'
import { CartItem } from 'lib/core/data/quote/cart/types'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { useCartSubscriptions } from 'hooks/cart'
import { useStoreView } from 'hooks/useStoreView'
import { Li } from './components/Styled'

interface Props {
  cartItem: CartItem
  isSpecialSupply?: boolean
}

export const ListItem: React.FC<Props> = ({ cartItem, isSpecialSupply }) => {
  const { quantity } = cartItem
  const {
    product,
    itemSubtotalWithDiscount
  } = useCartSubscriptions(cartItem)
  const { isLivBrite } = useStoreView()

  const {
    removeCartItem,
    isRemoveFetching,
    isRemoveDisabled,
    productPath,
    configurableOptions
  } = useCartItem({ cartItem })

  const imageUrl = product.image?.default.url

  return (
    <Li
      isLivBrite={isLivBrite}
    >
      <div className='product-data'>
        <div className='product-image'>
          <Link to={productPath}>
            <div
              style={{
                backgroundImage: `url(${imageUrl})`
              }}
            />
          </Link>
        </div>
        <div className='product-content'>
          <Link className='product-name' to={productPath}>
            {product.name}
          </Link>

          {configurableOptions && (
            <div className='product-options'>
              <ul>
                {configurableOptions.map(option => {
                  const { option_label: label, value_label: value, id } = option
                  return (
                    <li key={id}>
                      <span className='label'>{label}</span>
                      <span className='value'>{value}</span>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}

          <div className='product-subtotal'>
            <small>{quantity} <span>x</span></small>
            <Price
              currency={DEFAULT_CURRENCY_CODE}
              value={itemSubtotalWithDiscount}
            />
          </div>
        </div>

        <div className='product-remove'>
          <button
            onClick={removeCartItem}
            disabled={isRemoveDisabled}
          >
            {isRemoveFetching ? (
              <Spinner size={16} />
            ) : (
              <CloseSvg />
            )}
          </button>
        </div>
      </div>
    </Li>
  )
}
